import ReactMarkdown from 'react-markdown';
import ChatTools from './ChatTools';
import { Conversation } from '../../../../@types/IA.type';
import ChatIcon from '../../../../assets/img/png/h-chat-ai.png';
import { CircleNotch } from '@phosphor-icons/react';

const MessagesWrapper = ({
	messagesRef,
	currentConversation,
	isLoading,
	containerStyles,
	chatName,
}: {
	messagesRef: React.RefObject<HTMLDivElement>;
	currentConversation: Conversation;
	isLoading: {
		completion: boolean;
		history: boolean;
	};
	containerStyles?: string;
	chatName?: string;
}) => {
	if (isLoading.history)
		return (
			<div className='p-2 text-sm flex flex-col gap-4 overflow-y-auto h-full text-h-primary mt-2 items-center justify-center'>
				<CircleNotch
					className='animate-spin'
					size={32}
					weight='bold'
				/>
			</div>
		);

	return (
		<div
			className={`px-2 py-4 text-sm flex flex-col gap-4 overflow-y-auto ${containerStyles}`}
			ref={messagesRef}
		>
			{currentConversation?.thread?.map((message, index) => {
				const isLastMessage = index === currentConversation.thread.length - 1;
				const styles = {
					user: `ml-auto text-right ml-auto px-3 py-2 rounded-3xl bg-h-primary-90/70`,
					assistant: '',
				};

				const messageTools = message?.content
					? Array.from(
							message.content.matchAll(
								/www\.docsheru\.app\/\d+\/([^?\s]+)\?([^\s]+)/g,
							),
						)
							.map(([_url, functionName, params]) => {
								const parameters = new URLSearchParams(params);
								const args: Record<string, any> = {};

								for (const [key, value] of parameters.entries()) {
									args[key] = ['year', 'month'].includes(key)
										? parseInt(value)
										: value;
								}

								return {
									name: functionName.toLowerCase().replace(/-/g, '_'),
									args,
								};
							})
							.filter((tool): tool is NonNullable<typeof tool> => tool !== null)
					: [];

				if (messageTools && messageTools?.length > 0) {
					return (
						<ChatTools
							message={message}
							conversation={currentConversation}
							tools={messageTools}
							index={index}
						/>
					);
				}

				return (
					<div
						className='flex items-end'
						style={{
							animation: 'fadeInScale 0.150s ease forwards',
							animationDelay: `${index * 40}ms`,
							opacity: 0,
						}}
						key={`${message.content}-${index}`}
					>
						<div
							className={`w-fit font-light max-w-[90%] md:max-w-[80%] flex items-start gap-2 ${styles[message.role]}`}
						>
							{message.role === 'assistant' && (
								<img
									src={ChatIcon}
									alt='heru-ai'
									className='size-6 bg-h-primary rounded-full mb-1'
								/>
							)}
							<div>
								{chatName && message.role === 'assistant' && (
									<div className='text-xs text-h-neutral-60'>{chatName}</div>
								)}
								<ReactMarkdown className='whitespace-pre-wrap'>
									{message.content}
								</ReactMarkdown>
							</div>
						</div>
						{message.role === 'user' && (
							<div
								className={`text-h-primary size-3 ${
									isLastMessage && isLoading.completion ? 'w-3' : 'w-0'
								} overflow-hidden transition-all duration-300`}
							>
								<CircleNotch
									weight='bold'
									className='animate-spin w-full h-full'
								/>
							</div>
						)}
					</div>
				);
			})}
		</div>
	);
};

export default MessagesWrapper;
